export const GET_DEFER_RENEWAL_MONTHS = gql`
    query GetDeferRenewalMonths {
        deferRenewalMonths {
            id
            month
            createdAt
            updatedAt
        }
    }
`;
